package com.rainbowclubs.rainbow.domain.use_cases.membership

import com.rainbowclubs.rainbow.data.models.Membership
import com.rainbowclubs.rainbow.data.models.MembershipStatus
import com.rainbowclubs.rainbow.domain.repositories.MembershipRepository

class UpdateMembershipStatusUseCase(
    private val membershipRepository: MembershipRepository,
) {
    suspend operator fun invoke(
        membershipId: String,
        status: MembershipStatus,
    ): Result<Membership> {
        return membershipRepository.updateMembershipStatus(membershipId, status)
    }
}
